import React, { useState } from "react";
import Overview from "./Overview/Overview";
import Analytics from "./Analytics/Analytics";
import FinAnalytics from "./FInAnalytics/FinAnalytics";
import Notifications from "./Notifications/Notifications";
import styles from "./CampaignView.module.css";

const CampaignView = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const renderContent = () => {
    switch (activeTab) {
      case "overview":
        return <Overview />;
      case "analytics":
        return <Analytics />;
      case "FinAnalytics":
        return <FinAnalytics />;
        case "notifications":
          return <Notifications />;
      default:
        return <Overview />;
    }
  };

  return (
    <div className={styles.dashboardContainer}>
      <header className={styles.dashboardHeader}>
        <h1>Dashboard</h1>
        <div className={styles.dateDownload}>
          <div className={styles.dateRange}>
            <span>13 June 2023 - 14 July 2023</span>
          </div>
          <button className={styles.downloadButton}>Download</button>
        </div>
      </header>
      <div className={styles.dashboardNav}>
        <div className={styles.buttonContainer}>
          <button
            className={`${styles.navItem} ${
              activeTab === "overview" ? styles.active : ""
            }`}
            onClick={() => setActiveTab("overview")}
          >
            Overview
          </button>
          <button
            className={`${styles.navItem} ${
              activeTab === "analytics" ? styles.active : ""
            }`}
            onClick={() => setActiveTab("analytics")}
          >
            Analytics
          </button>
          <button
            className={`${styles.navItem} ${
              activeTab === "FinAnalytics" ? styles.active : ""
            }`}
            onClick={() => setActiveTab("FinAnalytics")}
          >
            Financial Analytics
          </button>
          <button
            className={`${styles.navItem} ${
              activeTab === "notifications" ? styles.active : ""
            }`}
            onClick={() => setActiveTab("notifications")}
          >
            Notifications
          </button>
        </div>
      </div>
      <div className={styles.contentContainer}>{renderContent()}</div>
    </div>
  );
};

export default CampaignView;
